<template>
  <v-app>
    <router-view :key="reloadKey" />
  </v-app>
</template>

<script setup>
import { ref, provide, onMounted, getCurrentInstance } from 'vue';
import { config } from './configState.js';
import { useBranding, setVuetifyInstance } from './logic/useBranding';

// 1. Der Zähler für den Reload
const reloadKey = ref(0);

// 2. Vuetify instance aus dem App-Context holen
const instance = getCurrentInstance();
const vuetify = instance.appContext.config.globalProperties.$vuetify;
if (vuetify) {
    setVuetifyInstance(vuetify);
    console.log('✅ Vuetify instance an useBranding übergeben');
} else {
    console.warn('⚠️ Vuetify instance nicht gefunden');
}

// 3. Branding/Theme Hook aufrufen (übernimmt Theme-Loading und CSS-Variablen)
useBranding();

// 4. Die Funktion, die wir an useWebRTC.js weiterreichen
const triggerAppReload = () => {
  console.log("[App] Soft-Reload wird ausgeführt...");
  reloadKey.value++; // Ändert den Key -> Vue zerstört und baut die View neu
};

// 5. Bereitstellen für alle Kinder (useWebRTC kann es jetzt injecten)
provide('appReload', triggerAppReload);

onMounted(() => {
  console.log(`🚀 App gestartet.`);
});
</script>